import { Badge } from '@/ux-common/components/badge/badge';
import { Inline } from '@/ux-common/components/inline/inline';
import { Tab } from '@/ux-common/components/tab/tab';
import { TabGroup } from '@/ux-common/components/tab-group/tab-group';

import { alarmTableViews } from './constants';
import { AlarmTableView, AlarmTableViewMeta } from './types';

type EquipmentDetailsAlarmTableBadgesProps = {
  tableView: AlarmTableView;
  setTableView: (tableView: AlarmTableView) => void;
  unacknowledgedCount: number;
  acknowledgedCount: number;
};

export const EquipmentDetailsAlarmTableBadges = ({
  tableView,
  unacknowledgedCount,
  acknowledgedCount,
  setTableView,
}: EquipmentDetailsAlarmTableBadgesProps) => {
  return (
    <Inline className={'inline-row-sm flex-nowrap min-w-0 flex-1 justify-end'}>
      <TabGroup
        items={alarmTableViews.map((view: AlarmTableViewMeta) => ({
          id: view.id,
          data: { label: view.name },
        }))}
        scrollable
        selectedIds={[tableView]}
        onSelectionChange={(items) =>
          setTableView((items[0]?.id as AlarmTableView) ?? 'unacknowledged-alarms')
        }
      >
        {({ tabs }) =>
          tabs.map(({ tab, state, disabled, onToggle }) => {
            const view = alarmTableViews.find((view: AlarmTableViewMeta) => view.id === tab.id);
            return (
              <Tab
                key={tab.id}
                data-state={state}
                disabled={disabled}
                onClick={onToggle}
                className="tab tab-sm"
              >
                {tab.data?.label}
                <Badge className="badge tab-badge">
                  {view?.id === 'unacknowledged-alarms' ? unacknowledgedCount : acknowledgedCount}
                </Badge>
              </Tab>
            );
          })
        }
      </TabGroup>
    </Inline>
  );
};
